export default "__VITE_ASSET__CPsqqO1L__"